import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Card,
  TextField,
  MenuItem,
  Button,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Typography,
  Switch,
  Pagination,
  Autocomplete,
} from "@mui/material";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import SystemHeaderNav from "../../components/HeadersNav/SystemHeaderNav";
import AuditLogHeader from "../../components/AuditLog/AuditLogHeader";
import { toast } from 'react-toastify';

export default function AuditLogSetting() {
  const [loading, setLoading] = useState(false);
  const [switchData, setSwitchData] = useState([]);
  const [updateSwitch, setUpdateSwitch] = useState(false);
  // const { enqueueSnackbar } = useSnackbar();

  const loadSwitshs = () => {
    setLoading(true);
    ApiService.get("/getTrackingJournalLog")
      .then(({ data }) => {
        // console.log("data", data.data);
        setLoading(false);
        setSwitchData(data.data);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };

  const changeSwitchFunction = (e, table) => {
    setUpdateSwitch(true);
    if (e.target.checked == true) {
      setSwitchData((prevState) => [...prevState, table]);
    } else {
      setSwitchData((prevState) => prevState.filter((item) => item != table));
    }
  };
  useEffect(() => {
    if (updateSwitch) {
      ApiService.post("/postTrackingJournalLog", {
        names: switchData.filter((item) => item != ""),
      });
    }
  }, [switchData]);
  useEffect(() => {
    loadSwitshs();
  }, []);

  return (
    <>
      <SystemHeaderNav />
      <Paper className=" p-4" style={{ marginTop: "1rem" }}>
        <div>
          <div>
            <Typography variant="h5">Journal Audit Log Setting</Typography>
            <div className="mt-4 mb-3">
              <AuditLogHeader value={1} />
            </div>
            {!loading && (
              <div>
                <p>Choose what system is tracking</p>
                <div className="d-flex">
                  <Box>
                    <Switch
                      sx={{
                        "& .MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked .MuiSwitch-track":
                          { background: "#F5F5F5" },
                      }}
                      // color="blue"
                      checked={switchData.includes("OvertimeShift")}
                      onChange={(e) => changeSwitchFunction(e, "OvertimeShift")}
                    />
                    <label>Overtime Shifts</label>
                  </Box>
                  <Box>
                    <Switch
                      sx={{
                        "& .MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked .MuiSwitch-track":
                          { background: "#F5F5F5" },
                      }}
                      // color="blue"
                      checked={switchData.includes("OvertimeShiftLog")}
                      onChange={(e) =>
                        changeSwitchFunction(e, "OvertimeShiftLog")
                      }
                    />
                    <label>Overtime Shifts Log</label>
                  </Box>
                  <Box>
                    <Switch
                      sx={{
                        "& .MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked .MuiSwitch-track":
                          { background: "#F5F5F5" },
                      }}
                      //   color="#2196f3"
                      checked={switchData.includes("EmployeeAssignment")}
                      onChange={(e) =>
                        changeSwitchFunction(e, "EmployeeAssignment")
                      }
                    />
                    <label>Employee Assignments</label>
                  </Box>
                </div>
              </div>
            )}
            <div>
              {loading && (
                <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                  <CircularProgress />
                </Box>
              )}
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
}
